module.exports = __webpack_public_path__ + "static/media/sync-exclamation.bf333164.svg";